const edu = {
 "about": {
  "whatH": "ما هو",
  "whatB": "يمنح FluentLoop للتعليم معلّمي المدرسة وطلابها تدريب GetFluentLoop اللغوي بالذكاء الاصطناعي، إضافةً إلى الفصول والواجبات للمعلّمين.",
  "pilotH": "الفترة التجريبية",
  "pilotB": "تحصل المدارس المُوثَّقة على فترة تجريبية مجانية مدتها 90 يومًا. دون بطاقة ائتمان، ولا تتحوّل أبدًا من تلقاء نفسها إلى خطة مدفوعة.",
  "whoH": "لمن هو",
  "whoB": "المدارس والجامعات ومدارس اللغات وغيرها من المؤسسات التعليمية، ويتقدّم بالطلب معلّم أو مسؤول في المدرسة.",
  "getH": "ما الذي تحصل عليه",
  "getB": "فصول بروابط انضمام، ومهام وواجبات، وعرض لتقدّم الفصل للمعلّمين.",
  "privacyH": "الخصوصية",
  "privacyB": "لا يرى المعلّمون إلا عمل الفصل. تبقى محادثات الطلاب الشخصية مع Fluent Friend ومذكّراتهم وسجلّ تعلّمهم الخاص سرّية. لا نحتفظ أبدًا بالصور أو التسجيلات الصوتية الأصلية.",
  "howH": "كيف يعمل",
  "howB": "قدّم طلبك أدناه. يراجع فريقنا كل طلب؛ فتقديم الطلب هو طلب وليس موافقة تلقائية. ستظهر الحالة هنا."
 },
 "publicSub": "فترة تجريبية مجانية لمدة 90 يومًا للمدارس المُوثَّقة.",
 "signupCta": "أنشئ حسابًا للتقديم",
 "signinCta": "تسجيل الدخول",
 "returnHint": "ستعود مباشرةً إلى هنا لتقديم الطلب بعد تسجيل الدخول.",
 "intro": "امنح طلابك فصلًا دراسيًا كاملًا من التدريب على الطلاقة اللغوية بالذكاء الاصطناعي — مجانًا للمدارس المُوثَّقة ودون بطاقة ائتمان.",
 "status": {
  "pending_review": "قيد المراجعة",
  "needs_information": "طُلبت معلومات إضافية",
  "approved": "تمت الموافقة",
  "rejected": "لم تتم الموافقة"
 },
 "approvedLine": "أصبح لمدرستك الآن وصول إلى FluentLoop Education. استمتع!",
 "teacherLink": "فتح لوحة المعلّم ←",
 "reviewerNote": "ملاحظة المراجِع: {note}",
 "submittedOn": "أُرسل في {date}. تقديم الطلب هو طلب وليس موافقة تلقائية.",
 "rejectedDefault": "لم تتم الموافقة على طلب مدرستك في الوقت الحالي.",
 "resubmit": "يمكنك تقديم طلب جديد أدناه.",
 "f": {
  "name": "اسم المؤسسة *",
  "type": "نوع المؤسسة",
  "country": "الدولة",
  "website": "موقع المؤسسة",
  "email": "بريدك المدرسي / بريد العمل",
  "role": "دورك",
  "learners": "العدد التقريبي للمتعلّمين",
  "notes": "ملاحظة قصيرة (اختياري)",
  "notesPh": "أخبرنا قليلًا عن برنامجك.",
  "disclaimer": "لا حاجة إلى بطاقة ائتمان. لا نجمع أبدًا بيانات الطلاب. الإرسال طلب يراجعه فريقنا، وليس موافقة تلقائية."
 },
 "types": {
  "school": "مدرسة",
  "university": "جامعة / كلية",
  "language_school": "مدرسة لغات",
  "training_center": "مركز تدريب",
  "educational_nonprofit": "منظمة تعليمية غير ربحية",
  "other_education": "مؤسسة تعليمية أخرى"
 },
 "roles": {
  "teacher": "معلّم",
  "school_admin": "إدارة المدرسة",
  "principal": "مدير المدرسة",
  "director": "مدير",
  "coordinator": "منسّق",
  "other": "أخرى"
 },
 "toast": {
  "needName": "يرجى إدخال اسم مؤسستك.",
  "alreadyOpen": "لديك طلب قيد المراجعة بالفعل.",
  "submitted": "تم إرسال الطلب!",
  "failed": "تعذّر إرسال الطلب."
 },
 "attest": "أؤكّد أنني أتقدّم بهذا الطلب بصفتي المهنية معلّمًا أو ممثّلًا مفوّضًا عن المدرسة.",
 "attestNeeded": "يرجى تأكيد إقرار المعلّم.",
 "vTitle": "نحتاج إلى بعض المعلومات الإضافية",
 "vIntro": "للتحقّق من دورك في المدرسة، يرجى مشاركة:",
 "proofs": {
  "institutional_email": "بريدك الإلكتروني المؤسّسي (المدرسي)",
  "staff_page": "رابط لصفحة رسمية للعاملين يظهر فيها اسمك",
  "school_admin_confirmation": "تأكيد من إدارة مدرستك",
  "other": "دليل آخر على انتمائك إلى المدرسة"
 },
 "vEmail": "البريد الإلكتروني المؤسّسي",
 "vEmailHint": "يُستخدم دليلًا فقط. لن يتغيّر بريد تسجيل الدخول الخاص بك.",
 "vUrl": "رابط صفحة العاملين الرسمية",
 "vNote": "ملاحظة قصيرة",
 "vSend": "إرسال المعلومات",
 "vReceived": "شكرًا، لقد استلمنا معلوماتك. لا يزال طلبك قيد المراجعة.",
 "vSent": "تم إرسال المعلومات.",
 "vFailed": "تعذّر إرسال معلوماتك.",
 "ev": {
  "submitted": "تم إرسال الطلب",
  "requested": "طُلبت معلومات إضافية",
  "response": "تم استلام المعلومات"
 }
};
Object.assign(edu, {
 "approvedOnly": "تمت الموافقة في {date}",
 "approvedActive": "تمت الموافقة في {date} · البرنامج التجريبي للمدرسة نشط حتى {end}",
 "approvedEnded": "تمت الموافقة في {date} · انتهى البرنامج التجريبي للمدرسة في {end}",
 "teach": {
  "welcome": "مرحبًا بك في FluentLoop for Education",
  "pilotActive": "البرنامج التجريبي التعليمي نشط · ينتهي في {date}",
  "pilotEnded": "انتهى البرنامج التجريبي التعليمي في {date}",
  "pilotInactive": "البرنامج التجريبي التعليمي غير نشط",
  "next": "ابدأ بإنشاء صف للغة التي تُدرّسها. ستحصل على رمز ورابط لمشاركتهما مع طلابك.",
  "createFirst": "أنشئ صفّك الأول",
  "howLink": "كيف يعمل FluentLoop for Education",
  "s1H": "أنشئ صفًا", "s1B": "اختر اللغة والمستوى.",
  "s2H": "ادعُ الطلاب", "s2B": "شارك رمز الصف أو رابطه. ينضم كل طالب بحسابه الخاص.",
  "s3H": "كلّف ودرّس", "s3B": "أنشئ مهام الطلاقة وكلّف بها صفّك.",
  "s4H": "تابع تقدّم الصف", "s4B": "اطّلع على إنجاز المهام ونشاط الصف.",
  "canSeeH": "ما يمكن للمعلمين رؤيته",
  "canSee": "أعضاء الصف|إنجاز المهام المكلّف بها|نشاط المدرسة والصف|نتائج دروسك ومهامك",
  "cantSeeH": "ما لا يمكن للمعلمين رؤيته",
  "cantSee": "محادثات Fluent Friend الخاصة|اليوميات|أدلة التعلّم الخاصة|التدريب الشخصي على المقابلات|التعلّم الشخصي غير المرتبط بالصف",
  "learnMore": "اعرف المزيد عن FluentLoop for Education",
  "missionLibrary": "مكتبة المهام",
  "createBtn": "إنشاء صف",
  "cancel": "إلغاء",
  "newClass": "صف جديد",
  "name": "اسم الصف",
  "namePh": "مثال: الإسبانية A1 — المجموعة 2",
  "lang": "اللغة التي يتعلّمها الطلاب",
  "level": "المستوى (الإطار الأوروبي)",
  "desc": "الوصف (اختياري)",
  "needOrg": "تحتاج إلى مدرسة لإنشاء صف.",
  "needName": "يرجى إدخال اسم الصف.",
  "created": "تم إنشاء الصف",
  "failed": "حدث خطأ ما. يرجى المحاولة مرة أخرى.",
  "activeClasses": "الصفوف النشطة",
  "activeStudents": "الطلاب النشطون",
  "schools": "المدارس",
  "noClasses": "لا توجد صفوف نشطة بعد.",
  "students": {"zero": "لا يوجد طلاب", "one": "طالب واحد", "two": "طالبان", "few": "{count} طلاب", "many": "{count} طالبًا", "other": "{count} طالب"},
  "code": "الرمز",
  "archived": "مؤرشفة",
  "notTeacher": "لست معلّمًا في أي مدرسة بعد.",
  "apply": "قدّم طلبًا عبر FluentLoop for Education",
  "requestContinuation": "طلب التمديد",
  "continuationPending": "تم طلب التمديد",
  "continuationSent": "تم طلب التمديد. سيراجعه فريقنا."
 },
 "cls": {
  "expiredH": "انتهى البرنامج التجريبي التعليمي",
  "expiredB": "تبقى الصفوف والمهام الحالية متاحة، لكن لا يمكن إنشاء عمل مدرسي جديد حتى يتم تجديد الوصول إلى Education.",
  "studentExpired": "انتهى وصول هذه المدرسة إلى Education، لذلك لا يمكن للطلاب الجدد الانضمام الآن. حسابك الشخصي في FluentLoop غير متأثر.",
  "archive": "أرشفة", "restore": "استعادة",
  "invite": "دعوة الطلاب", "classCode": "رمز الصف",
  "copyCode": "نسخ الرمز", "newCode": "رمز جديد", "copyLink": "نسخ رابط الدعوة", "newLink": "رابط جديد",
  "showQr": "إظهار رمز QR", "hideQr": "إخفاء رمز QR", "qrAlt": "رمز QR لرابط دعوة الصف",
  "qrNote": "يمكن للطلاب مسحه لفتح رابط دعوة الصف. يُنشأ على هذا الجهاز.",
  "codeCopied": "تم نسخ الرمز", "linkCopied": "تم نسخ الرابط", "regenerated": "تم إنشاء رمز جديد",
  "removed": "تمت إزالة الطالب من الصف", "remove": "إزالة من الصف",
  "progressFailed": "تعذّر تحميل التقدّم.", "resultsFailed": "تعذّر تحميل النتائج.",
  "noAccess": "ليس لديك وصول إلى هذا الصف.",
  "roster": "قائمة الصف ({n})", "noStudents": "لا يوجد طلاب بعد. شارك الرمز أو الرابط أعلاه.", "joined": "انضم في {date}",
  "progress": "التقدّم",
  "privacyNote": "عمل الصف فقط. لا يُعرض التعلّم الشخصي (Friend، اليوميات، المفردات الخاصة) أبدًا.",
  "aCompleted": "المهام المنجزة", "inProgress": "قيد التنفيذ", "notStarted": "لم تبدأ", "completed": "منجزة",
  "lastActivity": "آخر نشاط في الصف", "late": "(متأخرة)",
  "assignments": "المهام", "createMission": "إنشاء مهمة",
  "noAssignments": "لم تُكلَّف أي مهام بعد. أنشئ مهمة طلاقة ليتدرّب صفّك.",
  "minutes": "~{n} دقيقة", "due": {"overdue": "متأخرة", "due_today": "مستحقّة اليوم", "due_soon": "مستحقّة قريبًا"},
  "completedLower": "منجزة",
  "insights": "نظرة على الصف", "completionRate": "نسبة الإنجاز", "participation": "المشاركة",
  "assignedWords": "كلمات مكلَّف بها لا يزال الصف يتقنها", "needPractice": "مهام قد تحتاج إلى مزيد من التدريب",
  "pctDone": "أُنجز {n}%", "close": "إغلاق", "noStudentsInClass": "لا يوجد طلاب في هذا الصف بعد.",
  "joinTitle": "الانضمام إلى صف", "joinAuth": "سجّل الدخول أو أنشئ حسابك المجاني في FluentLoop للانضمام إلى هذا الصف.",
  "continue": "متابعة", "joinInvalid": "هذه الدعوة غير صالحة أو لم تعد نشطة.",
  "joinBtn": "الانضمام إلى هذا الصف", "joining": "جارٍ الانضمام…", "joinedToast": "لقد انضممت إلى الصف!", "joinFailed": "تعذّر الانضمام."
 },
 "stu": {
  "intro": "صفوفك المدرسية. يبقى تعلّمك الشخصي في FluentLoop منفصلًا وخاصًا.",
  "none": "لست في أي صف بعد.",
  "unfinished": "{n} للإنجاز", "completedN": "{n} منجزة", "pilotEndedTag": "انتهى البرنامج التجريبي",
  "pilotEnded": "انتهى البرنامج التجريبي لـ FluentLoop Education في مدرستك. حسابك الشخصي في FluentLoop لم يتغيّر.",
  "haveCode": "لديك رمز صف؟", "joinWithCode": "لديك رمز صف؟ انضم إلى صف",
  "continue": "متابعة", "start": "ابدأ", "teacher": "المعلّم",
  "assignments": "المهام", "noAssignments": "لا توجد مهام بعد.",
  "status": {"not_started": "لم تبدأ", "in_progress": "قيد التنفيذ", "completed": "منجزة"},
  "due": "موعد التسليم {date}", "classVocab": "مفردات الصف",
  "privacy": "يرى معلّمك عملك في هذا الصف فقط. يبقى تعلّمك الشخصي في FluentLoop خاصًا.",
  "pendingCount": {"zero": "لا توجد مهام مدرسية معلّقة", "one": "مهمة مدرسية واحدة معلّقة", "two": "مهمتان مدرسيتان معلّقتان", "few": "{count} مهام مدرسية معلّقة", "many": "{count} مهمة مدرسية معلّقة", "other": "{count} مهمة مدرسية معلّقة"},
  "signIn": "سجّل الدخول للانضمام", "signUp": "أنشئ حسابًا مجانيًا",
  "codeInvalid": "رمز الصف هذا غير صالح. يرجى التحقق منه مع معلّمك.",
  "tooMany": "محاولات كثيرة جدًا. يرجى الانتظار دقيقة ثم المحاولة مرة أخرى.", "tryAgain": "جرّب رمزًا آخر"
 },
 "faq": {
  "title": "أسئلة وأجوبة حول Education",
  "g": {"schools": "للمدارس والمعلمين", "privacy": "الخصوصية والبيانات", "students": "للطلاب", "pilot": "البرنامج التجريبي وانتهاؤه"},
  "what": {"q": "ما هو FluentLoop for Education؟", "a": "طريقة لتستخدم المدارس FluentLoop مع صفوفها. ينشئ المعلمون الصفوف ويكلّفون بمهام الطلاقة ويتابعون تقدّم الصف، بينما يحتفظ كل طالب بحسابه الخاص في FluentLoop."},
  "pilot90": {"q": "كيف يعمل البرنامج التجريبي المدرسي لمدة 90 يومًا؟", "a": "بعد الموافقة تحصل مدرستك على 90 يومًا من FluentLoop Education مجانًا. يحصل المعلمون والطلاب المسجّلون على وصول Education طوال مدة البرنامج."},
  "whoApply": {"q": "من يمكنه التقديم؟", "a": "المعلمون والموظفون المخوّلون في المدارس والجامعات ومدارس اللغات وغيرها من المؤسسات التعليمية."},
  "verified": {"q": "كيف يتم التحقق من المعلمين؟", "a": "يراجع فريقنا كل طلب. قبل الموافقة قد نطلب بريدًا إلكترونيًا مؤسسيًا أو رابطًا لصفحة رسمية لموظفي المدرسة. لا تتم الموافقة على أي طلب تلقائيًا."},
  "createClass": {"q": "كيف أنشئ صفًا؟", "a": "افتح لوحة المعلّم واختر إنشاء صف، ثم أدخل اسم الصف واللغة والمستوى."},
  "studentsJoin": {"q": "كيف ينضم الطلاب؟", "a": "شارك رمز الصف المكوّن من 6 أحرف أو رابط الدعوة أو رمز QR. يسجّل كل طالب الدخول بحسابه الخاص في FluentLoop ويؤكّد الصف."},
  "roles": {"q": "ما الفرق بين المعلّم ومسؤول المدرسة؟", "a": "يدير المعلمون صفوفهم. ويمكن لمسؤول المدرسة أيضًا إدارة جميع صفوف المدرسة وطلب تمديد البرنامج التجريبي."},
  "continuation": {"q": "كيف أطلب تمديد البرنامج التجريبي؟", "a": "مع اقتراب نهاية البرنامج، يمكن لمسؤول المدرسة اختيار طلب التمديد في لوحة المعلّم. يراجع فريقنا كل طلب."},
  "teacherSee": {"q": "ماذا يمكن للمعلمين رؤيته عن الطلاب؟", "a": "أعضاء الصف، والتقدّم في المهام المكلّف بها داخل الصف، ونشاط الصف، ونتائج دروسهم ومهامهم."},
  "teacherCant": {"q": "ما الذي لا يمكن للمعلمين رؤيته؟", "a": "أي شيء من تعلّم الطالب الشخصي في FluentLoop: محادثات Fluent Friend واليوميات وأدلة التعلّم الخاصة والمفردات الشخصية والتدريب الشخصي على المقابلات وسجلّ التدريب غير المرتبط بالصف."},
  "friendJournal": {"q": "هل يمكن للمعلمين رؤية محادثات Fluent Friend أو اليوميات؟", "a": "لا. تبقى محادثات Fluent Friend ومدخلات اليوميات خاصة دائمًا."},
  "personalVocab": {"q": "هل يمكن لمعلّمي رؤية مفرداتي الشخصية؟", "a": "لا. يرى المعلمون التقدّم في المفردات المكلّف بها داخل صفهم فقط."},
  "joinWhat": {"q": "ماذا يحدث عندما أنضم إلى صف في FluentLoop؟", "a": "يُضاف الصف إلى صفوفي، وتظهر مهام معلّمك هناك وفي لوحتك. لا تتم مشاركة أي شيء من حسابك الشخصي."},
  "personalAccount": {"q": "هل يمكنني الاستمرار في استخدام حسابي الشخصي في FluentLoop؟", "a": "نعم. يبقى كل ما في حسابك متاحًا، وفق حسابك وخطتك المعتادين."},
  "findClass": {"q": "أين أجد صفي؟", "a": "افتح المزيد ← صفوفي. يعرض كل صف مدرستك ومعلّمك ومهامك."},
  "findAssignments": {"q": "أين أجد المهام؟", "a": "داخل كل صف في صفوفي. ويظهر العمل المدرسي غير المكتمل أيضًا كبطاقة صغيرة في لوحتك."},
  "inviteLink": {"q": "ماذا يحدث عندما أنقر على رابط دعوة إلى صف؟", "a": "ترى الصف والمدرسة وتؤكّد رغبتك في الانضمام. إذا لم تكن قد سجّلت الدخول بعد، تسجّل الدخول أو تنشئ حسابًا أولًا ثم تعود مباشرة إلى الصف."},
  "multiClass": {"q": "هل يمكنني الانتماء إلى أكثر من صف؟", "a": "نعم. تظهر جميع صفوفك في صفوفي."},
  "leaveData": {"q": "هل يؤدي ترك صف مدرسي أو إنهاؤه إلى حذف بياناتي الشخصية في FluentLoop؟", "a": "لا. تبقى بياناتك الشخصية في FluentLoop في حسابك."},
  "pilotEnds": {"q": "ماذا يحدث عند انتهاء البرنامج التجريبي؟", "a": "لا يمكن إنشاء عمل مدرسي جديد: لا صفوف ولا مهام ولا مهام طلاقة جديدة، ولا يمكن لطلاب جدد الانضمام. لا يُحذف أي شيء، ويعود الوصول إذا جُدّد البرنامج."},
  "finishAfter": {"q": "هل يمكن للطلاب إكمال المهام الحالية بعد الانتهاء؟", "a": "نعم. يمكن للطلاب المسجّلين في صف إكمال المهام التي كُلّفوا بها قبل انتهاء البرنامج."},
  "dataAfter": {"q": "ماذا يحدث للصفوف والنتائج بعد الانتهاء؟", "a": "تبقى متاحة للاطّلاع. لا تُحذف الصفوف أو القوائم أو المهام أو النتائج."},
  "studentPilotEnds": {"q": "ماذا يحدث عندما ينتهي البرنامج التجريبي لمدرستي؟", "a": "يمكنك إكمال العمل الذي كلّفك به معلّمك سابقًا. حسابك الشخصي في FluentLoop لم يتغيّر."}
 }
});
export default edu;
